export const getFileFormat = (file: File) => {
	return file.name.split(".").pop() ?? ""
}
